'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  main: {
    border: '1px solid #ccc',
    width: '47px',
    height: '26px',
    borderRadius: '13px',
    cursor: 'pointer',
    display: 'inline-block',
    float: 'left'
  },
  toggle: {
    border: '1px solid #999',
    boxShadow: '1px 1px 1px #ccc',
    width: '25px',
    height: '24px',
    left: '0px',
    borderRadius: '12px',
    background: 'white',
    position: 'relative',
    transition: 'left .1s ease-in-out'
  },
  on: {
    background: 'green'
  },
  toggleOn: {
    left: '20px',
    color: 'green'
  }
};

exports.default = function (_ref) {
  var on = _ref.on;
  var onClick = _ref.onClick;
  var onIcon = _ref.onIcon;
  var offIcon = _ref.offIcon;
  var style = _ref.style;
  var labelStyle = _ref.labelStyle;
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { style: style },
    _react2.default.createElement(
      'div',
      { style: on ? _extends({}, styles.main, styles.on) : styles.main, onClick: onClick },
      _react2.default.createElement(
        'div',
        { style: on ? _extends({}, styles.toggle, styles.toggleOn) : styles.toggle },
        on ? onIcon : offIcon
      )
    ),
    children ? _react2.default.createElement(
      'div',
      { style: labelStyle },
      children
    ) : null
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/react-switcher/lib/index.js
// module id = 108
// module chunks = 0